import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginHotel() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("/api/hotel-admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "❌ خطأ في تسجيل الدخول");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("role", "hotel");
      localStorage.setItem("hotelId", data.hotel?.id || "");
      localStorage.setItem("userId", data.user?.id || "");

      navigate("/hotel-dashboard");
    } catch (err) {
      console.error(err);
      alert("❌ فشل الاتصال بالسيرفر");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="icon">🏨</div>
          <h2>تسجيل دخول الفندق</h2>
          <p>مرحباً بك، الرجاء إدخال البيانات</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>البريد الإلكتروني</label>
            <input
              type="email"
              placeholder="hotel@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>كلمة المرور</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn">
            تسجيل الدخول
          </button>
        </form>

        <div className="role-switcher">
          <span>تسجيل الدخول كـ</span>
          <div className="roles">
            <button onClick={() => navigate("/login")} className="admin">
              👑 إداري
            </button>
            <button onClick={() => navigate("/login-delivery")} className="delivery">
              🚚 توصيل
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .login-wrapper {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #fff3cd, #ffe8a1);
          font-family: "Segoe UI", Tahoma, sans-serif;
        }

        .login-card {
          background: #fff;
          width: 100%;
          max-width: 420px;
          padding: 30px;
          border-radius: 14px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }

        .login-header {
          text-align: center;
          margin-bottom: 25px;
        }

        .login-header .icon {
          font-size: 40px;
          margin-bottom: 10px;
        }

        .login-header h2 {
          margin: 0;
          font-size: 24px;
          color: #333;
        }

        .login-header p {
          margin-top: 5px;
          font-size: 14px;
          color: #777;
        }

        .form-group {
          margin-bottom: 18px;
          text-align: right;
        }

        .form-group label {
          display: block;
          margin-bottom: 6px;
          font-size: 14px;
          font-weight: 600;
          color: #555;
        }

        .form-group input {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 14px;
          outline: none;
        }

        .form-group input:focus {
          border-color: #ffc107;
        }

        .login-btn {
          width: 100%;
          padding: 13px;
          margin-top: 10px;
          background: #ffc107;
          color: #333;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: bold;
          cursor: pointer;
          transition: transform 0.2s, background 0.3s;
        }

        .login-btn:hover {
          background: #e0a800;
          transform: translateY(-1px);
        }

        .role-switcher {
          margin-top: 25px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          text-align: center;
        }

        .role-switcher span {
          display: block;
          margin-bottom: 12px;
          font-size: 14px;
          color: #666;
        }

        .roles {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .roles button {
          padding: 8px 16px;
          border: none;
          border-radius: 20px;
          font-size: 13px;
          font-weight: bold;
          cursor: pointer;
        }

        .roles .admin {
          background: #007bff;
          color: #fff;
        }

        .roles .admin:hover {
          background: #0056b3;
        }

        .roles .delivery {
          background: #28a745;
          color: #fff;
        }

        .roles .delivery:hover {
          background: #1e7e34;
        }
      `}</style>
    </div>
  );
}
